import { render, staticRenderFns } from "./Kform.vue?vue&type=template&id=07769f6c&scoped=true&"
import script from "./Kform.vue?vue&type=script&lang=js&"
export * from "./Kform.vue?vue&type=script&lang=js&"
import style0 from "./Kform.vue?vue&type=style&index=0&id=07769f6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07769f6c",
  null
  
)

export default component.exports